<div class="d-inline-flex align-items-center">
  <ng-container *ngFor="let step of steps; let i = index">
    <div
      class="d-flex flex-column outer-ring"
      [class.clickable]="clickable && activeStep !== step && step <= largestStep"
      [class.active]="activeStep >= step"
      [class.selected]="activeStep === step"
      (click)="selectStep(step)"
    >
      <div class="flex-grow-1"></div>
      <div class="inner-ring align-self-center" [class.active]="activeStep >= step"></div>
      <div class="flex-grow-1"></div>
    </div>
    <ng-container *ngIf="step !== numberOfSteps">
      <div
        class="separator"
        [class.active]="activeStep > step"
        [class.shrink]="activeStep === step || activeStep === step + 1"
      ></div>
    </ng-container>
  </ng-container>
</div>
